import { createSlice } from "@reduxjs/toolkit";

const initialStateList = {
  abroad_counselling_list: [],
  test_prep_list: [],
  career_counselling_list: [],
  other_services_list: [],
  profile_building_list: [],
  mode: "",
};

const servicesSlice = createSlice({
  name: "service",
  initialState: initialStateList,
  reducers: {
    setServices: (state, action) => {
      const {
        abroad_counselling_list,
        test_prep_list,
        career_counselling_list,
        other_services_list,
        profile_building_list,
      } = action.payload;

      if (abroad_counselling_list) {
        state.abroad_counselling_list = abroad_counselling_list;
      }
      if (test_prep_list) {
        state.test_prep_list = test_prep_list;
      }
      if (career_counselling_list) {
        state.career_counselling_list = career_counselling_list;
      }
      if (other_services_list) {
        state.other_services_list = other_services_list;
      }
      if (profile_building_list) {
        state.profile_building_list = profile_building_list;
      }
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },

    clearService: () => initialStateList,
  },
});

export const { setServices, clearService } = servicesSlice.actions;

export default servicesSlice.reducer;
